module.exports = __webpack_public_path__ + "img/stock5.c0b7fd6f.png";